import DistributorIcon from '@assets/icons/services/distributor.svg?react';
import InstallerIcon from '@assets/icons/services/installer.svg?react';
import RetailShopIcon from '@assets/icons/services/retail_shop.svg?react';
import WebshopIcon from '@assets/icons/services/webshop.svg?react';
import { TableHeader } from '@common/types/common';
import {
    CompaniesHeader,
    CompanyAllowedReasonTypes,
    CompanyMembersHeader,
    Services,
    UserRequestsHeader,
} from '@company/types/company';

const COMPANY_OVERVIEW_TABLE_HEADERS_Public_USER: TableHeader<CompanyMembersHeader>[] = [
    { id: 'user__full_name', label: 'Name' },
    { id: 'role', label: 'Role' },
];

const COMPANY_OVERVIEW_TABLE_HEADERS_DASHBOARD_USER: TableHeader<CompaniesHeader>[] = [
    { id: 'name', label: 'Company Name', width: '30%' },
    { id: 'services', label: 'Services', width: '30%', disabled: true },
    { id: 'country', label: 'Country', width: '' },
];

const COMPANY_OVERVIEW_TABLE_HEADERS_DASHBOARD_REQUEST: TableHeader<UserRequestsHeader>[] = [
    { id: 'company__name', label: 'Company Name' },
    { id: 'company__company_type', label: 'Type', width: '12%' },
    { id: 'company__country', label: 'Country' },
    { id: 'request_type', label: 'Request Type', width: '20%' },
    { id: 'status', label: 'Status' },
    { id: 'isrequestProccessed', label: 'Request/Proccess', disabled: true },
];

const REASONS_TYPES = [
    {
        reason: CompanyAllowedReasonTypes.NO_EXACT_ACCOUNT,
        message: 'Exact account required to request a distributor company',
    },
];

const COMPANY_TABLE_ROWS_PER_PAGE = 20;

const getReasonMessage = (type?: string) =>
    REASONS_TYPES.find((item) => item.reason === type)?.message || 'Unknown reason please contact support';

const companySetupSteps = [
    {
        title: 'Setup',
        fields: ['name', 'vat_number', 'chamber_of_commerce_number', 'services', 'markets_ids', 'owner_id'],
    },
    {
        title: 'Information',
        fields: [
            'address',
            'city',
            'country_code',
            'province',
            'phone_number',
            'fax_number',
            'commercial_email',
            'support_emails',
            'website',
            'sales_manager_id',
        ],
    },
    { title: 'Details', fields: ['description'] },
];

const SERVICES_ICONS: Record<
    Services,
    {
        icon: React.FunctionComponent<
            React.SVGProps<SVGSVGElement> & {
                title?: string;
            }
        >;
    }
> = {
    [Services.DISTRIBUTOR]: {
        icon: DistributorIcon,
    },
    [Services.INSTALLER]: {
        icon: InstallerIcon,
    },
    [Services.RETAIL_SHOP]: {
        icon: RetailShopIcon,
    },
    [Services.WEBSHOP]: {
        icon: WebshopIcon,
    },
};

export {
    COMPANY_OVERVIEW_TABLE_HEADERS_DASHBOARD_REQUEST,
    COMPANY_OVERVIEW_TABLE_HEADERS_DASHBOARD_USER,
    COMPANY_OVERVIEW_TABLE_HEADERS_Public_USER,
    COMPANY_TABLE_ROWS_PER_PAGE,
    companySetupSteps,
    getReasonMessage,
    REASONS_TYPES,
    SERVICES_ICONS,
};
